import React from "react";

export default function Loading() {
  return <div className="loading-container dashboard-with-sources">
    <div className="loader">
      <i className="fas fa-spinner fa-spin" />
    </div>
  </div>;
}
